import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"

// Everything about the player's money in one request: the balance, whether today's grant is
// waiting, what a game costs, which classes they own, and the last few movements. Read at
// bootstrap and again after anything that spends — see `walletFromResponse` for why the shape is
// translated here rather than in the components.
export const thunk = createAsyncThunk("economy/getWallet", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/credits/")
    return walletFromResponse(response.data)
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

// The backend answers snake_case; the store keeps camelCase (see the convention in CLAUDE.md).
// Exported because three thunks answer with a wallet — reading it, claiming the daily grant, and
// buying a class — and a second copy of this mapping is a second place for a key to be missed.
export const walletFromResponse = (data) => ({
  credits: data.credits,
  daily: {
    amount: data.daily?.amount ?? 0,
    claimable: Boolean(data.daily?.claimable),
    nextClaimAt: data.daily?.next_claim_at ?? null,
  },
  gameEntryCost: data.game_entry_cost,
  unlockedRaces: data.unlocked_races ?? [],
  // Which looks and reactions this account holds. With the wallet rather than with the shop for
  // the same reason as the classes: the reaction tray is drawn on the game screen, and most
  // sessions never open the shop.
  ownedCosmetics: data.owned_cosmetics ?? [],
  // What the account wears, so the header and the profile draw the player's own picture.
  ...(data.equipped_cosmetics ? { equippedCosmetics: data.equipped_cosmetics } : {}),
  history: (data.history ?? []).map((entry) => ({
    amount: entry.amount,
    reason: entry.reason,
    reference: entry.reference,
    balanceAfter: entry.balance_after,
    createdAt: entry.created_at,
  })),
})

export const onSucceed = economyReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
